import script from "./Error.vue?vue&type=script&setup=true&lang=js"
export * from "./Error.vue?vue&type=script&setup=true&lang=js"

import "./Error.vue?vue&type=style&index=0&id=89bc9170&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89bc9170"]])

export default __exports__